import Nullstack from 'nullstack';
export default function IconFrameOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-frame-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 7h3m4 0h9"
  }), "   ", Nullstack.element("path", {
    d: "M4 17h13"
  }), "   ", Nullstack.element("path", {
    d: "M7 7v13"
  }), "   ", Nullstack.element("path", {
    d: "M17 4v9m0 4v3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}